import { render, staticRenderFns } from "./sendTemplateOnMail.vue?vue&type=template&id=3ef6610a&scoped=true"
import script from "./sendTemplateOnMail.vue?vue&type=script&lang=js"
export * from "./sendTemplateOnMail.vue?vue&type=script&lang=js"
import style1 from "./sendTemplateOnMail.vue?vue&type=style&index=1&id=3ef6610a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef6610a",
  null
  
)

export default component.exports